import { pluralizePhrase } from "@app/common/utils";

import ExpandableList from "@rui/ExpandableList";

import { KeyFactor } from "./styles";

const DEFAULT_VISIBLE_FACTORS = 2;

const KeyFactors = ({ reasons }: { reasons: string[] }) => {
  const numHiddenFactors = reasons.length - DEFAULT_VISIBLE_FACTORS;

  return (
    <ExpandableList
      max={DEFAULT_VISIBLE_FACTORS}
      buttonProps={{
        viewMoreLabel: `+${pluralizePhrase(numHiddenFactors, "more factor")}`,
        sx: { fontFamily: (theme) => theme.typography.fontFamily, pl: "19px" },
      }}
    >
      {reasons.map((factor) => (
        <KeyFactor key={factor}>{factor}</KeyFactor>
      ))}
    </ExpandableList>
  );
};

export default KeyFactors;
